module.exports = __webpack_public_path__ + "img/75976.a7f3e00d.svg";